
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.334 11.333c0 .4-.255.667-.638.667H4.782C2.677 12 .955 10.2.955 8s1.722-4 3.827-4h1.914c.383 0 .638.267.638.667s-.255.666-.638.666H4.782c-1.403 0-2.551 1.2-2.551 2.667 0 1.467 1.148 2.667 2.551 2.667h1.914c.383 0 .638.266.638.666zM12.437 4h-1.914c-.382 0-.638.267-.638.667s.256.666.638.666h1.914c1.403 0 2.552 1.2 2.552 2.667 0 1.467-1.149 2.667-2.552 2.667h-1.914c-.382 0-.638.266-.638.666s.256.667.638.667h1.914c2.105 0 3.827-1.8 3.827-4s-1.722-4-3.827-4zM6.058 8.667c-.383 0-.638-.267-.638-.667s.255-.667.638-.667h5.103c.383 0 .638.267.638.667s-.255.667-.638.667H6.058z","fill":"#000"}})])
          )
        }
      }
    